import { useCallback } from 'react';
export const useScrollToSection = (selector) => {
    return useCallback(() => {
        const element = document.querySelector(selector);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, [selector]);
};
